import styled from "styled-components";

export const BasketContainer = styled.div`
  border: 1px solid #ddd;
  padding: 10px;
  margin-top: 20px;
`;

export const BetItem = styled.div`
  margin: 5px 0;
  padding: 1rem;
  border: 1px solid red;
`;

